import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=49a08e3d&scoped=true"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a08e3d",
  null
  
)

export default component.exports